import React, {FunctionComponent} from "react";
import styles from "./AxisTitle.module.css"

export const AxisTitle: FunctionComponent = () => {
    return (
        <div className={styles.axisTitle}>
            Range (mm)
        </div>
    )
}